// eslint-disable-next-line max-statements
(function () {

  var pageType = $('#vault-ticket-modal').attr('data-page-type');


  function allowSend(enabled) {
    if (enabled) {
      $('.modal-footer .btn-primary').removeAttr('disabled');
    } else {
      $('.modal-footer .btn-primary').attr('disabled', '');
    }
  }

  function receiveCreateTicketResponse(resp, callback) {
    var response = JSON.parse(resp.responseText);
    response = (response[0]) ? response[0] : response;

    if (resp.status === 200 || resp.status === 201) {
      var ticketLink = $('#ticket-link-path').val() + response.key;
      var ticketMsg = '<a href="' + ticketLink + '">' + response.key + '</a>';
      return callback(null, {
        status: 'success', header: 'Ticket created:', message: ticketMsg
      });
    }

    allowSend(true);
    return callback(null, {
      status: 'danger', header: 'Error:', message: response.message
    });

  }

  function stripTags(text) {
    return text.replace(/(<([^>]+)>)/ig, '');
  }

  function getTicketInfo() {
    return stripTags($('#ticket-info').val().trim());
  }

  function getAgentAlias() {
    var infoJomax = JSON.parse(ux.utils.cookie.get('info_jomax') || null);
    return infoJomax ? infoJomax.loginname : '';
  }

  function sendCreateTicketMessage(callback) {

    allowSend(false);

    var reasonVal = $('#ticket-reason').val();

    var createTicketMsg = {
      contentId: $('#ticket-id').val(),
      articleStatus: $('#ticket-articleStatus').val(),
      contentTitle: $('#ticket-title').val(),
      contentLink: $('#ticket-link').val(),
      agentAlias: stripTags($('#ticket-agent-alias').val()),
      reason: reasonVal,
      reasonText: $('#ticket-reason option[value="' + reasonVal + '"]').text(),
      info: getTicketInfo(),
      pageType: pageType
    };

    $.ajax({
      datatype: 'json',
      contentType: 'application/json; charset=utf-8',
      type: 'POST',
      url: requestContext.hostPath + '/ajax/createTicket',
      data: JSON.stringify(createTicketMsg)
    })
      .complete(function (resp) {
        return receiveCreateTicketResponse(resp, callback);
      });
  }

  function checkIsValid() {
    var isValid = true;

    var agentAlias = $('#ticket-agent-alias').val().trim();
    if (!agentAlias) {
      isValid = false;
    }

    var isMakePublic = ($('#ticket-reason').val() === 'makePublic');

    var ticketInfo = getTicketInfo();
    if (!ticketInfo && !isMakePublic) {
      isValid = false;
    }

    allowSend(isValid);
  }

  function agentAliasInput() {
    checkIsValid();
  }

  function ticketInfoInput() {
    checkIsValid();
  }

  function ticketReasonChange() {

    var reason = $('#ticket-reason').val();
    var text = '';

    if (reason === 'makePublic') {
      text = '';
    } else if (reason === 'newArticle') {
      text = 'Enter product name and briefly describe needed information.';
    } else if (reason === 'badInfo') {
      if (pageType === 'article') {
        text = '• Copy and paste the incorrect words, or first sentence of that ' +
          'section.  (If image, where is it on page: 1st image, 2nd, 3rd, etc.)\n• What ' +
          'should it say instead? Is there someone other than yourself we should contact' +
          ' for more information?';
      } else if (pageType === 'product') {
        text = '• If something is wrong, exactly what is the string of text ' +
          'that\'s incorrect? What should should it say instead?\n' +
          '• If something is missing, what is it and where should we place the new information?';
      }
    }

    $('#ticket-info').attr('placeholder', text);

    checkIsValid();
  }

  $('body').bind('ajaxSend', function (elm, xhr, s) {
    if (s.type === 'POST') {
      var csrfToken = $('#_csrf').val();
      if (csrfToken) {
        xhr.setRequestHeader('X-CSRF-Token', csrfToken);
      }
    }
  });

  function showFeedbackDialog() {
    $('#ticket-agent-alias').val(getAgentAlias());
    $('#ticket-agent-alias').attr('placeholder', 'Enter agent alias');
    $('#ticket-reason').val('makePublic');
    $('#ticket-info').val('');
    $('#ticket-info').attr('placeholder', '');
    ticketReasonChange();
  }

  function sendFeedback(callback) {
    return sendCreateTicketMessage(callback);
  }

  $('#ticket-reason').on('change', ticketReasonChange);
  $('#ticket-agent-alias').on('input', agentAliasInput);
  $('#ticket-info').on('input', ticketInfoInput);

  window.gdvault = window.gdvault || {};
  window.gdvault.showFeedbackDialog = showFeedbackDialog;
  window.gdvault.sendFeedback = sendFeedback;

}());
